import React, { useContext } from 'react';
import * as PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';

import { storeContext } from '../../../../../context';
import { StyledPaymentItemContainer } from '../../../../../theme/styledElements';
import PaymentItemData from './PaymentItemData';
import PaymentItemButton from './PaymentItemButton';
import OneClickPaymentButton from './OneClickPaymentButton';

/**
 * A components which wraps text, amount and a payment button
 * @param {Number} type - PaymentItem.paymentTypes enum
 * @param {Number} popoverType - one of PaymentItem.popoverTypes
 */
const PaymentItem = observer(props => {
  const {
    payable: {
      hasPaymentPlan,
      estimatedAmountDue,
      selectableNextPayment,
      oneClickPaymentMethod
    },
    userState,
    translations: { currentLanguage }
  } = useContext(storeContext);

  const { MAKE_A_PAYMENT } = PaymentItem.paymentTypes;
  const showOneClickPaymentButton =
    !hasPaymentPlan &&
    oneClickPaymentMethod?.creditCard &&
    selectableNextPayment <= oneClickPaymentMethod.amount;

  const {
    type = MAKE_A_PAYMENT,
    buttonColor = 'secondary',
    popoverType = PaymentItem.popoverTypes.ANCHOR_TO_BOTTOM
  } = props;

  userState.set('paymentItemPopoverType', popoverType);

  return (
    <StyledPaymentItemContainer
      data-testid="paymentItem"
      className="paymentItem"
    >
      <PaymentItemData amount={estimatedAmountDue} type={type}>
        {showOneClickPaymentButton && (
          <OneClickPaymentButton
            balance={estimatedAmountDue}
            amountToPay={selectableNextPayment}
            creditCard={oneClickPaymentMethod.creditCard}
          />
        )}
        <PaymentItemButton type={type} buttonColor={buttonColor} />
      </PaymentItemData>
    </StyledPaymentItemContainer>
  );
});

PaymentItem.paymentTypes = {
  MAKE_A_PAYMENT: 1,
  VIEW_PAYMENT_PLAN_OPTIONS: 2,
  PAYMENT_PLAN: 3
};

PaymentItem.popoverTypes = {
  ANCHOR_TO_BOTTOM: 1,
  ANCHOR_TO_TOP: 2
};

PaymentItem.propTypes = {
  type: PropTypes.number,
  buttonColor: PropTypes.string,
  popoverType: PropTypes.oneOf([
    PaymentItem.popoverTypes.ANCHOR_TO_BOTTOM,
    PaymentItem.popoverTypes.ANCHOR_TO_TOP
  ])
};

export default PaymentItem;
